import { createSlice } from '@reduxjs/toolkit'

export const keySlicer = createSlice({
  name: 'value',
  initialState: {
    value: ''
  },
  reducers: {

    set: (state, action) => {
        state.value = action.payload;
    },
  },
})

// Action creators are generated for each case reducer function
export const { set } = keySlicer.actions

export default keySlicer.reducer